export default __webpack_public_path__ + "static/media/1884.ef23805b.png";